import React from 'react';
import { ProductPriceString } from '../utils/ProductPriceString';
import { successTickImageUrl } from '../utils/Constants';

export const BundlerParentProduct = ({ parentProduct, customProdcutData }) => {
  // console.log(customProdcutData,'customProdcutData',parentProduct)
  return (
    <div className="xrs-parent-product">
      <div className="xrs-product__success-message">
        <img src={successTickImageUrl} alt="success" className="success-img" />
        <p>Added to Cart</p>
      </div>
      <div className="xrs-parent-image">
        <img
          src={
            // parentProduct.productImage === undefined
            //   ? parentProduct.url_image
            //   : parentProduct.productImage
            customProdcutData.customProImg
              ? customProdcutData.customProImg
              : parentProduct.productImage === undefined
              ? parentProduct.url_image
              : parentProduct.productImage
              
          }
          // Ensure HTML encoded entities display properly
          alt={
            // parentProduct.variantName

            customProdcutData.customProName
            ? customProdcutData.customProName
            : (parentProduct.productName+'-'+parentProduct.variantTitle)
          }
          className="xrs-product__image"
          width="170px"
          height="170px"
        />
      </div>
      <div className="xrs-product-name-price-block" data-testid="productname">
        {/* <p className="xrs-product-name-text" id="xcs-parentname">
          {parentProduct.productName}-{parentProduct.variantTitle}
        </p> */}
      
          {customProdcutData.customProName
            ? (<p className="xrs-product-name-text" id="xcs-parentname">{customProdcutData.customProName}</p>)
            : <p className="xrs-product-name-text" id="xcs-parentname">{parentProduct.productName}-{parentProduct.variantTitle}</p>} 
        {customProdcutData.customProPrice ? (<p id="xcs-parent-price">{customProdcutData.customProPrice}</p>) : (<p id="xcs-parent-price">
          <ProductPriceString
            price={parentProduct.price}
            compareAtPrice={parentProduct.compareAtPrice}
            currency={
              parentProduct.currency !== undefined
                ? parentProduct.currency
                : 'USD'
            }
          />
        </p>)}
        
      </div>
    </div>
  );
};
